export default __webpack_public_path__ + "static/media/xlsx.94185a1b.svg";